import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex-grow-1 m-auto" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "d-flex align-items-center mb-2" }
const _hoisted_11 = { class: "text-gray-800 text-hover-primary fs-3 fw-bolder me-1" }
const _hoisted_12 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_13 = { class: "d-flex align-items-center text-hover-primary mb-2" }
const _hoisted_14 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Email: ", -1)
const _hoisted_16 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_17 = { class: "d-flex align-items-center text-hover-primary mb-2" }
const _hoisted_18 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Mobile: ", -1)
const _hoisted_20 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_21 = { class: "d-flex align-items-center text-hover-primary me-5 mb-2" }
const _hoisted_22 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Present Address: ", -1)
const _hoisted_24 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_25 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold flex-nowrap" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = {
  key: 0,
  class: "card"
}
const _hoisted_28 = { class: "" }
const _hoisted_29 = {
  class: "tab-content",
  id: "kt_tabs"
}
const _hoisted_30 = {
  class: "mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder container m-0 text-primary border-bottom border-2 py-5 px-8" }, " Profile Details ", -1)
const _hoisted_32 = { class: "card-body p-9" }
const _hoisted_33 = { class: "row mb-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Full Name", -1)
const _hoisted_35 = { class: "col-lg-8" }
const _hoisted_36 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_37 = { class: "row mb-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Mobile", -1)
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "fw-bold fs-6" }
const _hoisted_41 = { class: "row mb-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Email", -1)
const _hoisted_43 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_44 = { class: "fw-bold fs-6 me-2" }
const _hoisted_45 = { class: "row mb-2" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Date of Birth", -1)
const _hoisted_47 = { class: "col-lg-8" }
const _hoisted_48 = { class: "fw-bold fs-6 me-2" }
const _hoisted_49 = { class: "row mb-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " NID ", -1)
const _hoisted_51 = { class: "col-lg-8" }
const _hoisted_52 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_53 = { class: "row mb-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Father's Name", -1)
const _hoisted_55 = { class: "col-lg-8" }
const _hoisted_56 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_57 = { class: "row mb-2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Mother's Name", -1)
const _hoisted_59 = { class: "col-lg-8" }
const _hoisted_60 = { class: "fw-bold fs-6" }
const _hoisted_61 = { class: "row mb-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Passport", -1)
const _hoisted_63 = { class: "col-lg-8" }
const _hoisted_64 = { class: "fw-bold fs-6" }
const _hoisted_65 = { class: "row mb-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Gender", -1)
const _hoisted_67 = { class: "col-lg-8" }
const _hoisted_68 = { class: "fw-bold fs-6" }
const _hoisted_69 = { class: "row mb-2" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Religion", -1)
const _hoisted_71 = { class: "col-lg-8" }
const _hoisted_72 = { class: "fw-bold fs-6" }
const _hoisted_73 = { class: "row mb-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Present District:", -1)
const _hoisted_75 = { class: "col-lg-8" }
const _hoisted_76 = { class: "fw-bold fs-6" }
const _hoisted_77 = { class: "row mb-2" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Present Address:", -1)
const _hoisted_79 = { class: "col-lg-8" }
const _hoisted_80 = { class: "fw-bold fs-6" }
const _hoisted_81 = { class: "row mb-2" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Permanent District:", -1)
const _hoisted_83 = { class: "col-lg-8" }
const _hoisted_84 = { class: "fw-bold fs-6" }
const _hoisted_85 = { class: "row mb-2" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Permanent Address:", -1)
const _hoisted_87 = { class: "col-lg-8" }
const _hoisted_88 = { class: "fw-bold fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: 
                _ctx.employeeInfo?.attach_file_info?.file_path
                  ? _ctx.api_url + _ctx.employeeInfo?.attach_file_info?.file_path
                  : 'media/avatars/blank.png'
              ,
                alt: "",
                width: "100"
              }, null, 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", _hoisted_11, "About " + _toDisplayString(_ctx.employeeInfo?.name), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                    ]),
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.employeeInfo?.email), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "media\\icons\\duotune\\electronics\\elc003.svg" })
                    ]),
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.employeeInfo?.mobile), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
                    ]),
                    _hoisted_23,
                    _createTextVNode(" " + _toDisplayString(_ctx.employeeInfo?.present_address), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("ul", _hoisted_25, [
            _createElementVNode("li", _hoisted_26, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 0 }]),
                "data-bs-toggle": "tab",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveTab($event))),
                "data-tab-index": "0",
                href: "#overview",
                role: "tab"
              }, " Overview ", 2)
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    (_ctx.tabIndex === 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 0 }]),
                id: "overview"
              }, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.employeeInfo?.name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.employeeInfo?.mobile), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.employeeInfo?.email), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.employeeInfo?.dob), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.employeeInfo?.nid), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.employeeInfo?.father_name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.employeeInfo?.mother_name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.employeeInfo?.passport), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.employeeInfo?.gender), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _hoisted_70,
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.employeeInfo?.religion), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _hoisted_74,
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.employeeInfo?.present_district?.district_name_eng), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _hoisted_78,
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.employeeInfo?.present_address), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _hoisted_82,
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.employeeInfo?.permanent_district?.district_name_eng), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _hoisted_86,
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.employeeInfo?.permanent_address), 1)
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true)
  ], 64))
}